<template>
  <div>
    <div class="row">
      <div class="col-12">
<!--        <card type="chart">-->
<!--          <template slot="header">-->
<!--            <div class="row">-->
<!--              <div class="col-sm-6" :class="isRTL ? 'text-right' : 'text-left'">-->
<!--                <h5 class="card-category">{{$t('dashboard.totalShipments')}}</h5>-->
<!--                <h2 class="card-title">{{$t('dashboard.performance')}}</h2>-->
<!--              </div>-->
<!--              <div class="col-sm-6">-->
<!--                <div class="btn-group btn-group-toggle"-->
<!--                     :class="isRTL ? 'float-left' : 'float-right'"-->
<!--                     data-toggle="buttons">-->
<!--                  <label v-for="(option, index) in bigLineChartCategories"-->
<!--                         :key="option"-->
<!--                         class="btn btn-sm btn-primary btn-simple"-->
<!--                         :class="{active: bigLineChart.activeIndex === index}"-->
<!--                         :id="index">-->
<!--                    <input type="radio"-->
<!--                           @click="initBigChart(index)"-->
<!--                           name="options" autocomplete="off"-->
<!--                           :checked="bigLineChart.activeIndex === index">-->
<!--                    {{option}}-->
<!--                  </label>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </template>-->
<!--          <div class="chart-area">-->
<!--            <line-chart style="height: 100%"-->
<!--                        ref="bigChart"-->
<!--                        chart-id="big-line-chart"-->
<!--                        :chart-data="bigLineChart.chartData"-->
<!--                        :gradient-colors="bigLineChart.gradientColors"-->
<!--                        :gradient-stops="bigLineChart.gradientStops"-->
<!--                        :extra-options="bigLineChart.extraOptions">-->
<!--            </line-chart>-->
<!--          </div>-->
<!--        </card>-->
      </div>
    </div>
    <div class="row">
      <div class="col-lg-4" :class="{'text-right': isRTL}">
        <card type="chart">
          <template slot="header">
            <h5 class="card-category">{{$t('dashboard.dailySales') + ' ' + currentYear}}</h5>
            <h3 class="card-title"><i class="tim-icons icon-chart-bar-32 text-info "></i> {{dataFromDb.total_projects}} </h3>
          </template>
          <div class="chart-area">
            <bar-chart style="height: 100%"
                       ref="blueChart"
                       chart-id="blue-bar-chart"
                       :chart-data="blueBarChart.chartData"
                       :gradient-stops="blueBarChart.gradientStops"
                       :extra-options="blueBarChart.extraOptions">
            </bar-chart>
          </div>
        </card>
      </div>
      <div class="col-lg-4" :class="{'text-right': isRTL}">
        <card type="chart">
          <template slot="header">
            <h5 class="card-category">{{$t('dashboard.completedTasks') + ' ' + currentYear}}</h5>
            <h3 class="card-title"><i class="tim-icons icon-money-coins text-success "></i> {{dataFromDb.total_value}} lei</h3>
          </template>
          <div class="chart-area">
            <line-chart style="height: 100%"
                        ref="greenChart"
                        chart-id="green-line-chart"
                        :chart-data="purpleLineChart.chartData"
                        :gradient-stops="purpleLineChart.gradientStops"
                        :extra-options="purpleLineChart.extraOptions">
            </line-chart>
          </div>
        </card>
      </div>
      <div class="col-lg-4" :class="{'text-right': isRTL}">
        <card type="chart">
          <template slot="header">
            <h5 class="card-category">{{$t('dashboard.totalShipments') + ' ' + currentYear}}</h5>
            <h3 class="card-title"><i class="tim-icons icon-coins text-primary "></i> {{dataFromDb.total_payments}} lei</h3>
          </template>
          <div class="chart-area">
            <line-chart style="height: 100%"
                        chart-id="purple-line-chart"
                        :chart-data="greenLineChart.chartData"
                        :gradient-colors="greenLineChart.gradientColors"
                        :gradient-stops="greenLineChart.gradientStops"
                        :extra-options="greenLineChart.extraOptions">
            </line-chart>
          </div>
        </card>
      </div>
    </div>
    <div class="row">
      <task-list></task-list>
    </div>
  </div>
</template>
<script>
  import LineChart from '@/components/Charts/LineChart';
  import BarChart from '@/components/Charts/BarChart';
  import * as chartConfigs from '@/components/Charts/config';
  import TaskList from './Dashboard/TaskList';
  import UserTable from './Dashboard/UserTable';
  import config from '@/config';
  import axios from "axios";

  export default {
    components: {
      LineChart,
      BarChart,
      TaskList,
      UserTable
    },
    data() {
      return {
        dataFromDb: {},
        currentYear: new Date().getFullYear(),
        // bigLineChart: {
        //   allData: [
        //     [100, 70, 90, 70, 85, 60, 75, 60, 90, 80, 110, 100],
        //     [80, 120, 105, 110, 95, 105, 90, 100, 80, 95, 70, 120],
        //     [60, 80, 65, 130, 80, 105, 90, 130, 70, 115, 60, 130]
        //   ],
        //   activeIndex: 0,
        //   chartData: {
        //     datasets: [{ }],
        //     labels: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
        //   },
        //   extraOptions: chartConfigs.purpleChartOptions,
        //   gradientColors: config.colors.primaryGradient,
        //   gradientStops: [1, 0.4, 0],
        //   categories: []
        // },
        greenLineChart: {
          extraOptions: chartConfigs.purpleChartOptions,
          chartData: {
            labels: ['JAN', 'FEB', 'MAR', 'APR', 'MAI', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
            datasets: [{
              label: "Incasari",
            }]
          },
          gradientColors: config.colors.primaryGradient,
          gradientStops: [1, 0.2, 0],
        },
        purpleLineChart: {
          extraOptions: chartConfigs.greenChartOptions,
          chartData: {
            labels: ['JUL', 'AUG', 'SEP', 'OCT', 'NOV'],
            datasets: [{
              label: "Valoare contracte",
            }]
          },
          gradientColors: ['rgba(66,134,121,0.15)', 'rgba(66,134,121,0.0)', 'rgba(66,134,121,0)'],
          gradientStops: [1, 0.4, 0],
        },
        blueBarChart: {
          extraOptions: chartConfigs.barChartOptions,
          chartData: {
            labels: ['IAN', 'FEB', 'MAR', 'APR', 'MAI', 'IUN','IUL', 'AUG', 'SEPT', 'OCT', 'NOI', 'DEC'],
            datasets: [{
              label: "Proiecte",
            }]
          },
          gradientColors: config.colors.primaryGradient,
          gradientStops: [1, 0.4, 0],
        }
      }
    },
    computed: {
      enableRTL() {
        return this.$route.query.enableRTL;
      },
      isRTL() {
        return this.$rtl.isRTL;
      },
      bigLineChartCategories() {
        return this.$t('dashboard.chartCategories');
      }
    },
    methods: {
      initBlueChart() {
        let chartData = {
          datasets: [{
            label: "Proiecte",
            fill: true,
            borderColor: config.colors.info,
            borderWidth: 2,
            borderDash: [],
            borderDashOffset: 0.0,
            data: [8, 12, 10, 1, 9, 1, 9, 1, 8, 9, 7, 1], //this.dataFromDb.projects_no,
          }],
          labels: ['JAN', 'FEB', 'MAR', 'APR', 'MAI', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
        };
        this.blueBarChart.chartData = chartData;
      },
      initPurpleChart() {
        let chartData = {
          datasets: [{
            label: "Valoare contracte",
            fill: true,
            borderColor: config.colors.danger,
            borderWidth: 2,
            borderDash: [],
            borderDashOffset: 0.0,
            pointBackgroundColor: config.colors.danger,
            pointBorderColor: 'rgba(255,255,255,0)',
            pointHoverBackgroundColor: config.colors.danger,
            pointBorderWidth: 20,
            pointHoverRadius: 4,
            pointHoverBorderWidth: 15,
            pointRadius: 4,
            data: [1000, 700, 900, 700, 850, 600, 750, 600, 900, 800, 1100, 1000], //this.dataFromDb.projects_contract_val,
          }],
          labels: ['JAN', 'FEB', 'MAR', 'APR', 'MAI', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
        };
        this.purpleLineChart.chartData = chartData;
      },
      initGreenChart() {
        let chartData = {
          datasets: [{
            label: "Incasari",
            fill: true,
            borderColor: config.colors.primary,
            borderWidth: 2,
            borderDash: [],
            borderDashOffset: 0.0,
            pointBackgroundColor: config.colors.primary,
            pointBorderColor: 'rgba(255,255,255,0)',
            pointHoverBackgroundColor: config.colors.primary,
            pointBorderWidth: 20,
            pointHoverRadius: 4,
            pointHoverBorderWidth: 15,
            pointRadius: 4,
            data: [1000, 700, 900, 700, 850, 600, 750, 600, 900, 800, 1100, 1000], //this.dataFromDb.payments,
          }],
          labels: ['JAN', 'FEB', 'MAR', 'APR', 'MAI', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
        };
        this.greenLineChart.chartData = chartData;
      },
      // initBigChart(index) {
      //   let chartData = {
      //     datasets: [{
      //       fill: true,
      //       borderColor: config.colors.primary,
      //       borderWidth: 2,
      //       borderDash: [],
      //       borderDashOffset: 0.0,
      //       pointBackgroundColor: config.colors.primary,
      //       pointBorderColor: 'rgba(255,255,255,0)',
      //       pointHoverBackgroundColor: config.colors.primary,
      //       pointBorderWidth: 20,
      //       pointHoverRadius: 4,
      //       pointHoverBorderWidth: 15,
      //       pointRadius: 4,
      //       data: this.bigLineChart.allData[index]
      //     }],
      //     labels: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
      //   }
      //   this.$refs.bigChart.updateGradients(chartData);
      //   this.bigLineChart.chartData = chartData;
      //   this.bigLineChart.activeIndex = index;
      // }
    },
    watch: {
      dataFromDb: function() {
        // this.initBigChart(0);
        this.initBlueChart();
        this.initPurpleChart();
        this.initGreenChart();
      }
    },
    mounted() {
      // this.i18n = this.$i18n;
      if (this.enableRTL) {
        this.$rtl.enableRTL();
        this.i18n.locale = 'ro';
      }
      // this.initBigChart(0);

      axios.post('projectsData', {year: new Date().getFullYear()})
              .then(res => {
                this.dataFromDb = res.data;
              })
              .catch(err => {
                console.log(err);
              })
    },
    beforeDestroy() {
      if (this.$rtl.isRTL) {
        this.i18n.locale = 'ro';
        this.$rtl.disableRTL();
      }
    }
  };
</script>
<style>
</style>
